import { Controller } from "stimulus";
import { getActiveCurrency, formatCurrency } from "../util/currency";
import { EventCurrencyChanged } from "../events";
import { stockChartOptions, HIGHCHARTS_DATE_FORMAT } from "../config";
import CoinGeckoThumbnailImage from "images/coingecko-greyscale.png";
export default class extends Controller {
  static targets = ["chart", "chartType", "toolbar"];

  connect() {
    this._renderChart();
    window.addEventListener(EventCurrencyChanged, e => this._renderChart());
  }

  updateChart(e) {
    const buttonEl = e.currentTarget;

    // Clear active on siblings
    const $buttonEl = $(buttonEl);
    $buttonEl.siblings().removeClass("active");
    $buttonEl.addClass("active");

    this._renderChart();
  }

  _renderChart() {
    this._updateChartDataLinks();
    const chartUrl = this.toolbarTarget.querySelector(".active").getAttribute("data-stablecoins-chart-url");
    const activeCurrencyCode = getActiveCurrency();
    const chartName = this.chartTypeTarget.querySelector(".active").getAttribute("data-chart-name");
    const chartType = this.chartTypeTarget.querySelector(".active").getAttribute("data-chart-type");
    const monetaryFlag = this.chartTypeTarget.querySelector(".active").getAttribute("data-monetary-flag") === "true";
    const elementId = this.chartTarget.id;

    fetch(chartUrl, { credentials: "same-origin" })
      .then(response => response.json())
      .then(data => {
        if (data === null) {
          return;
        }
        const seriesDataArray = data;

        Promise.all([
          import("highcharts/highstock")
        ]).then(res => {
          const [Highcharts] = res;

          const chart = Highcharts.chart(
            Object.assign(
              stockChartOptions(elementId),
              {
                time: { useUTC: false },
                title: "",
                chart: {
                  height: 500,
                  type: chartType,
                  zoomType: 'x',
                  renderTo: elementId,
                },
                navigator: {
                  enabled: true
                },
                xAxis: {
                  type: "datetime",
                  title: {
                    enabled: false
                  }
                },
                yAxis: {
                  title: {
                    text: null
                  },
                  showLastLabel: true,
                  opposite: false,
                  labels: {
                    align: 'left',
                    x: 0,
                    y: -2,
                    formatter() {
                      if (monetaryFlag) {
                        return formatCurrency(this.value, activeCurrencyCode);
                      } else {
                        return `${this.value.toFixed(2)}%`;
                      }
                    }
                  },
                },
                series: seriesDataArray,
                plotOptions: {
                  area: {
                    stacking: "percent",
                    lineWidth: 2,
                    fillOpacity: 0.05,
                    marker: {
                      enabled: false
                    }
                  },
                  line: {
                    marker: {
                      enabled: false
                    }
                  }
                },
                tooltip: {
                  shared: true,
                  formatter() {
                    const date = this.points[0].series.chart.time.dateFormat(HIGHCHARTS_DATE_FORMAT, this.points[0].x);
                    var formatter = `${date}<br/>`;

                    this.points.forEach(point => {
                      var yValue;
                      if (monetaryFlag) {
                        yValue = formatCurrency(point.y, activeCurrencyCode);
                      } else {
                        yValue = `${point.y.toFixed(2)}%`;
                      }

                      formatter += `<span style='color:${point.color}'>\u25CF</span> ${point.series.name}: <b>${yValue}</b><br/>`;
                    });

                    return formatter;
                  }
                }
              }
            )
          );

          chart.renderer.image(CoinGeckoThumbnailImage, chart.chartWidth - 115,chart.chartHeight - 190,100,28).add();
        })
      });
  }

  _updateChartDataLinks() {
    var toolbarButtons = Array.from(this.toolbarTarget.children);

    const activeCurrencyCode = getActiveCurrency();
    const baseUrl = new URL(this.chartTypeTarget.querySelector(".active").getAttribute("data-chart-base-url"));

    for (let item of toolbarButtons) {
      const url = new URL(item.dataset.stablecoinsChartUrl);
      var searchParams = new URLSearchParams(url.search);
      searchParams.set("vs_currency", activeCurrencyCode);

      if (this.chartTarget === item) {
        const activeChartDuration = this.toolbarTarget.querySelector(".active").getAttribute("data-days");;
        searchParams.set("days", activeChartDuration);
      }

      url.search = searchParams.toString();
      url.pathname = baseUrl.pathname;
      item.dataset.stablecoinsChartUrl = url.href;
    }
  }
}
